import { Skeleton } from "shared/components/atoms/Skeleton";

export const DivinationTagCardListSkeleton = () => {
  return (
    <div tw="flex p-5">
      <Skeleton width={96} height={137} tw="rounded mr-2" />
      <Skeleton width={96} height={137} tw="rounded mr-2" />
      <Skeleton width={96} height={137} tw="rounded mr-2" />
      <Skeleton width={96} height={137} tw="rounded mr-2" />
    </div>
  );
};
